module.exports = {
      id: "script-writer-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#script-writer",
      toString: function () {
        return this.url;
      }
    }